/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { MenuItem, ListItemText, OutlinedInput } from '@mui/material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from 'formik';
import { Row, Col, Form } from 'react-bootstrap';
import TextInput from 'components/input/textInput';
import { CssSelect } from 'components/helper/helperInut';
import SelectInput from 'components/input/SelectInput';
import { optionValues } from 'components/helper/helper';
import SuggestCourse from 'screen/course/SuggestCourse';

import {
  subjectAreaOptions,
  subjectOptions,
} from 'screen/course/courseConstant';

export const A_F_Grade = [
  { value: 'A+' },
  { value: 'A'  },
  { value: 'A-' },
  { value: 'B+' },
  { value: 'B'  },
  { value: 'B-' },
  { value: 'C+' },
  { value: 'C'  },
  { value: 'C-' },
  { value: 'D+' },
  { value: 'D'  },
  { value: 'D-' },
  { value: 'F'  },
];

export const genGradeOptions = (gradingScale:string) => {
  console.log('genGradeOptions:', gradingScale);
  switch (gradingScale) {
    case 'A-F':
      return A_F_Grade;
    case '0-100':
    case '0-105':
    case '1-100':
      return [...optionValues(Array.from({ length: 106 }, (_, i) => i))];
    case '0-110':
      return [...optionValues(Array.from({ length: 111 }, (_, i) => i))];
    case '0.0-4.0':
      return [ ...optionValues(Array.from({ length: 41 }, (_, i) => i / 10))];
    case '0.0-5.0':
      return [ ...optionValues(Array.from({ length: 51 }, (_, i) => i / 10))];
    case '1-7':
    case '1-7 (IB)':
      return [...optionValues(Array.from({ length: 7 }, (_, i) => i + 1))];
    case '1-10':
      return [...optionValues(Array.from({ length: 10 }, (_, i) => i + 1))];
    case '1-11':
      return [ ...optionValues(Array.from({ length: 11 }, (_, i) => i + 1))];
    case '1-20':
      return [...optionValues(Array.from({ length: 20 }, (_, i) => i + 1))];
    default:
      return [];
  }
}

export const genTermOptions = (schedule: string, gradeNo:number) => {
  let termOptions:any[] = [];
  if (gradeNo===13) { 
    termOptions = [
      { name: 'Final', value: 'Final'},
    ];
    return termOptions;    
  }

  /*
    LABELS ONLY, 2026-09-24 (ClickUp #86ak9ab4g).

    A trimester school's third term was being called "Semester 3" and a quarter
    school's four terms were "Semester 1" through "Semester 4". Michelle, on
    seeing it: "it's ridiculous." It is, and it teaches a student the wrong word
    for their own transcript.

    `name` is what the student reads; `value` is what is stored in
    gpa_forecast_detail.term. Only `name` changes here. The stored values stay
    exactly as they are, so no existing row is orphaned, no migration is needed
    and nothing that reads `term` has to change. Renaming the stored values is a
    separate ticket with a real migration behind it.
  */
  termOptions= [
    { name: 'Final', value: 'Final'},
    { name: 'Term 1', value: 'Semester 1'},
    { name: 'Term 2', value: 'Semester 2'},
    { name: 'Term 3', value: 'Semester 3'},
    { name: 'Term 4', value: 'Semester 4'},
  ];
  switch(schedule) {
    case 'Semester':
    case 'Standard':
    case 'Half-Credit Semester':
      termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Semester 1', value: 'Semester 1'},
        { name: 'Semester 2', value: 'Semester 2'},
      ];
      break;
    case 'Trimester':
      termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Trimester 1', value: 'Semester 1'},
        { name: 'Trimester 2', value: 'Semester 2'},
        { name: 'Trimester 3', value: 'Semester 3'},
      ];
      break;
    case 'Quarter':
    case 'Quarters':
       termOptions = [
        { name: 'Final', value: 'Final'},
        { name: 'Quarter 1', value: 'Semester 1'},
        { name: 'Quarter 2', value: 'Semester 2'},
        { name: 'Quarter 3', value: 'Semester 3'},
        { name: 'Quarter 4', value: 'Semester 4'},
      ];
      break;
    case 'Yearly':
    case 'Other':      
    default:
        termOptions = [
          { name: 'Final', value: 'Final'},
        ];
      break;
  }
  return termOptions;
}


/**
 * Validation shared by Add and Edit of a custom course. Returns field -> message;
 * an empty object means the course can be saved.
 */
export const validateCustomCourse = (v: any, termOptions: any[]): Record<string, string> => {
  const errs: Record<string, string> = {};
  if (!v?.gpa_forecast_id) errs.school = 'Select a school.';
  if (!`${v?.course ?? ''}`.trim()) errs.course = 'Course Name is required.';
  if (!`${v?.subject_area ?? ''}`.trim()) errs.subject_area = 'A-G Subject Area is required.';

  const term = `${v?.term ?? ''}`.trim();
  if (!term) errs.term = 'Term is required.';
  else if (termOptions?.length && !termOptions.some((o: any) => o.value === term)) {
    errs.term = 'Term is not valid for this school schedule.';
  }

  // Grade must be one of the values of the school's grading scale (A-F letters, 0-100 numbers, ...).
  const grade = `${v?.grade ?? ''}`.trim();
  const gradeOpts = genGradeOptions(v?.grading_scale ?? '');
  const sameGrade = (o: any) => {
    const a = `${o?.value ?? ''}`;
    if (a.toUpperCase() === grade.toUpperCase()) return true;
    return a !== '' && grade !== '' && !Number.isNaN(Number(a)) && !Number.isNaN(Number(grade)) && Number(a) === Number(grade);
  };
  if (!grade) errs.grade = 'Grade is required.';
  else if (gradeOpts.length && !gradeOpts.some(sameGrade)) {
    errs.grade = `Grade must match the school's grading scale (${v?.grading_scale || 'unknown'}).`;
  }

  // Points: each must be a number >= 0, and at least one of the two must be > 0
  // (both 0 is rejected, whatever the grade).
  const isNum = (x: any) => x !== '' && x !== null && x !== undefined && !Number.isNaN(Number(x));
  ([['unweighted_point', 'Unweighted points'], ['weighted_point', 'Weighted points']] as const).forEach(([k, label]) => {
    if (!isNum(v?.[k])) errs[k] = `${label} must be a number.`;
    else if (Number(v[k]) < 0) errs[k] = `${label} cannot be negative.`;
  });
  if (!errs.unweighted_point && !errs.weighted_point
      && Number(v.unweighted_point) === 0 && Number(v.weighted_point) === 0) {
    errs.points = 'Unweighted points or Weighted points must be greater than 0.';
  }

  if (!isNum(v?.credit) || Number(v.credit) <= 0) errs.credit = 'Credits must be greater than 0.';
  return errs;
};

type Props = {
  gradeNo: number;
  open: boolean;
  options: any[];
  handleSave: (values: any) => void;
  onClose: () => void;
  /** 'edit' pre-fills the dialog from editRow (a gpa_forecast_detail row) and locks the school. */
  mode?: 'add' | 'edit';
  editRow?: any;
};

const FormCreateGpaForecastModal = ({ gradeNo, options, open, handleSave, onClose, mode = 'add', editRow = null }: Props) => {
  const isEdit = mode === 'edit' && !!editRow;
  const [errors, setErrors] = React.useState<Record<string, string>>({});
  const schedule = `${(options && options.length>0) ? options[0].schedule : ''}`
  const gradingScale= `${(options && options.length>0) ? options[0].grading_scale : ''}`;
  console.log('FormCreateGpaForecastModal - options:',options);
  console.log('gradingScale:', gradingScale);
  // school_year is already an array of year strings. The old code pushed that whole
  // array as ONE option, so the School Year combo rendered a single blank row.
  const schoolYears:any[] = (options && options.length>0 && Array.isArray(options[0].school_year))
    ? options[0].school_year
    : [];
 
  const [searchKey, setSearchKey] = React.useState('');
  const [yearOptions, setYearOptions] =  React.useState<any[]>(schoolYears);
  const [termOptions, setTermOptions] = React.useState<any[]>(genTermOptions(schedule, gradeNo));
  const [gradeOptions, setGradeOptions] = React.useState<any[]>(genGradeOptions(gradingScale));
  const [school, setSchool] = React.useState<any>( (options && options.length>0) ? options[0]: null);
  const formik = useFormik({
    initialValues: {
      gpa_forecast_id: (options && options.length>0) ? options[0].gpa_forecast_id : undefined,
      school_name: (options && options.length>0) ? options[0].school_name: '',
      grading_scale: (options && options.length>0) ? options[0].grading_scale: '',
      schedule: (options && options.length>0) ? options[0].schedule: '',
      school_year: (options && options.length>0 && options[0]?.school_year && options[0]?.school_year.length>0) ? options[0]?.school_year[0] : '',
      school_code: (options && options.length>0) ? options[0]?.school_code : '',
      course: '',
      term: (termOptions && termOptions.length>0) ? termOptions[0].value : 'Final',
      grade: (gradeOptions && gradeOptions.length>0) ? gradeOptions[0].value : '',
      credit: 1,
      is_weight_point: false,
      unweighted_point: '',
      weighted_point: '',
      subject_area: '',
      discipline: '',
    },
    onSubmit: (values) => {
      handleSave(values);
    },
  });

 const highschoolData = options && options.length>0 ? options[0]?.highschoolData || null: null; 
 
 const [disciplineOptions, setDisciplineOptions] = React.useState<any>(subjectOptions);

  const getDisciplineByType = (type: any) => {
    try {
      let list = disciplineOptions.filter((o: any) => {
        return o.type === type;
      });

      if (list.length > 0) {
        list.push({ value: 'Other', type: '' });
        return list;
      }
    } catch (ex) {
      // skip
    }
    return subjectOptions;
  };

  React.useEffect(() => {
    if (!open) {
      formik.resetForm();
      setErrors({});
    }
  }, [open]);

  // useState/useFormik initial values are captured on the first render only, when the
  // school options may not be loaded yet (and resetForm() restores those stale values).
  // Re-apply the school every time the dialog opens or the options change:
  // Add uses options[0]; Edit uses the row's own block and fills in the row's values.
  React.useEffect(() => {
    if (!open || !options || options.length === 0) return;
    const first: any = isEdit
      ? (options.find((o: any) => o.gpa_forecast_id === editRow.gpa_forecast_id) ?? options[0])
      : options[0];
    const years: any[] = Array.isArray(first.school_year) ? first.school_year : [];
    const terms = genTermOptions(first.schedule, gradeNo);
    const grades = genGradeOptions(first.grading_scale);
    setSchool(first);
    setYearOptions(years);
    setTermOptions(terms);
    setGradeOptions(grades);
    setErrors({});
    const base = {
      ...formik.values,
      gpa_forecast_id: first.gpa_forecast_id,
      school_name: first.school_name,
      grading_scale: first.grading_scale,
      schedule: first.schedule,
      school_code: first.school_code ?? '',
      school_year: years.length > 0 ? years[0] : '',
      term: terms.length > 0 ? terms[0].value : 'Final',
      grade: grades.length > 0 ? grades[0].value : '',
    };
    formik.setValues(isEdit ? {
      ...base,
      course: editRow.course ?? '',
      term: editRow.term ?? base.term,
      grade: editRow.grade ?? base.grade,
      credit: editRow.credit ?? '',
      is_weight_point: !!editRow.is_weight_point,
      unweighted_point: editRow.unweighted_point ?? '',
      weighted_point: editRow.weighted_point ?? '',
      subject_area: editRow.ag_subject_area ?? '',
    } : base);
  }, [open, options, editRow]);

  // Validate, then save; invalid fields are listed above the buttons and nothing is saved.
  const handleSaveClick = () => {
    const errs = validateCustomCourse(formik.values, termOptions);
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;
    handleSave(formik.values);
    onClose();
  };

  // A custom course must attach to an EXISTING gpa_forecast row (one per school block).
  // Without one, the old Save posted gpa_forecast_id = NaN, the request failed silently
  // and the dialog closed as if it had worked. Mirror the V2 AddCourseModal guard instead.
  const hasSchoolOptions = !!(options && options.length > 0);
  const gradeLabel = gradeNo === 13 ? 'College Course' : `Grade ${gradeNo}`;

  return (
    <React.Fragment>
      {open && (
      <div className="custom-accordion">
        <div className="custom-accordion-item">
          <h2 className="custom-accordion-header">
            {isEdit ? 'Edit GPA Forecast Information' : 'New GPA Forecast Information'}
          </h2>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>

          <div className="custom-accordion-body">
            {!hasSchoolOptions ? (
              // No school block exists for this grade yet, so there is nothing to attach a course to.
              <div className="pt-2 pb-2" style={{ lineHeight: 1.6 }}>
                There is no school set up for {gradeLabel} yet. Add the school and its courses in
                Courses &amp; Grades first, then click Refresh Data here to add individual courses.
              </div>
            ) : (
            <div className="pt-2">
              <Row className="pb-2">
                <Form.Group
                    name="gpa_forecast_id"
                    as={Col}
                    md={6}
                    className="ps-1 pe-2 py-2"
                >
                <Form.Label className={`select-label label-14px`}>School Name</Form.Label>
                  <div style={{ backgroundColor: 'white', borderRadius: '0.5rem'}}>
                    <CssSelect
                      name = "select_school"
                      // The row belongs to its school block; moving it to another block is not an edit.
                      disabled={isEdit}
                      value={school}
                      onChange={(e:any) => {
                          let obj:any = e.target.value;
                          if (obj) {
                            formik.setFieldValue('gpa_forecast_id', obj.gpa_forecast_id);
                            formik.setFieldValue('school_name', obj.school_name);
                            formik.setFieldValue('schedule', obj.schedule);
                            // grading_scale was not updated on school change, so the read-only
                            // field kept showing the previous school's scale.
                            formik.setFieldValue('grading_scale', obj.grading_scale);
                            formik.setFieldValue('school_code', obj.school_code);
                            setTermOptions(genTermOptions(obj.schedule, gradeNo));
                            setGradeOptions(genGradeOptions(obj.grading_scale));
                            setYearOptions(Array.isArray(obj.school_year) ? obj.school_year : []);
                            formik.setFieldValue('school_year', obj.school_year && obj.school_year.length>0 ? obj.school_year[0]:'');
                          }
                          setSchool(obj);
                      }}
                      input={<OutlinedInput label="Tag" />}
                      renderValue={(o:any)=> o.school_name}
                      >
                      {options && options.length>0 && options.map((e) => (
                        <MenuItem key={e.gpa_forecast_id} value={e}>
                          <ListItemText primary={e.school_name} />
                        </MenuItem>
                      ))}
                    </CssSelect>
                  </div>
                </Form.Group>
                <SelectInput
                  id={`schoolYear`}
                  form={formik}
                  option={yearOptions}
                  mdCol="4"
                  label="School Year*"
                  values={formik.values.school_year}
                  // Must match the formik field; "schoolYear" wrote the pick to a field nobody reads.
                  name="school_year"
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  id={`courseName`}
                  mdCol="12"
                  label="Course Name*"
                  countText={100}
                  name="course"
                  values={formik.values.course}
                  onChange={(e) => {
                    setSearchKey(e.target.value);
                    formik.handleChange(e);
                  }}
                />
                {searchKey?.length > 0 ? (
                  <SuggestCourse
                    searchKey={searchKey}
                    schoolYear={formik.values.school_year}
                    currentHighschool={highschoolData}
                    onUpdateCourseTitle={(course:any) => {
                      if (course) {
                        formik.setFieldValue('subject_area', course.subject_area);
                        formik.setFieldValue('discipline', course.discipline);
                        formik.setFieldValue('course', course.course_title);
                      }
                    }}
                  />
                ) : null}

              <SelectInput
                form={formik}
                option={subjectAreaOptions}
                label="A-G Subject Area"
                values={formik.values.subject_area}
                name={'AGSubjectArea'}
                onChange={formik.handleChange}
                readOnly={true}
              />
              <SelectInput
                form={formik}
                option={getDisciplineByType(formik.values.subject_area)}
                label="Subject/Discipline"
                values={formik.values.discipline}
                name={`discipline`}
                onChange={formik.handleChange}
                readOnly={true}
              />
              </Row>

              <Row className="py-2">
                <TextInput
                  mdCol={3}
                  label="Schedule"
                  values={formik.values.schedule}
                  name="schedule"
                  onChange={formik.handleChange}
                  readOnly={true}
                />
                <TextInput
                  mdCol={3}
                  label="Grading Scale"
                  values={formik.values.grading_scale}
                  name="grading_scale"
                  onChange={formik.handleChange}
                  readOnly={true}
                />
                <SelectInput 
                  mdCol={3}
                  option={termOptions}
                  label="Term"
                  values={formik.values.term}
                  name="term"
                  onChange={formik.handleChange}
                />
                <SelectInput 
                  mdCol={3}
                  option={gradeOptions}
                  label="Grade"
                  values={formik.values.grade}
                  name="grade"
                  onChange={formik.handleChange}
                  />
              </Row>
              <Row className="py-2">
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Unweighted point"
                  values={formik.values.unweighted_point}
                  name="unweighted_point"
                  onChange={(e:any)=>{
                    formik.setFieldValue('is_weight_point', false);
                    // formik.setFieldValue('weighted_point', 0);
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Weighted point"
                  values={formik.values.weighted_point}
                  name="weighted_point"
                  onChange={(e:any)=>{
                    formik.setFieldValue('is_weight_point', true);
                    // formik.setFieldValue('unweighted_point', 0);
                    formik.handleChange(e);
                  }}
                />
                <TextInput
                  type="number"
                  decimalStep={0.1}
                  mdCol={4}
                  label="Credits"
                  values={formik.values.credit}
                  name="credit"
                  onChange={formik.handleChange}
                />
              </Row>
            </div>
            )}
            {Object.keys(errors).length > 0 && (
              // Validation result of the last Save click; nothing is saved while this list is shown.
              <ul className="mt-2 mb-0 ps-4" style={{ color: '#d32f2f', fontSize: '14px' }}>
                {Object.entries(errors).map(([k, msg]) => (
                  <li key={k}>{msg}</li>
                ))}
              </ul>
            )}
          </div>
          <div className="custom-accordion-footer d-flex justify-content-end">
              <Button className="btn-custom"
                variant="outlined"
                style={{marginRight: "1em"}}
                onClick={onClose}>Cancel</Button>
              <Button className="btn-custom"
                variant="contained"
                style={{marginRight: "1em"}}
                // No school block = nothing to attach to; every other rule is checked on click.
                disabled={!hasSchoolOptions}
                onClick={handleSaveClick}>Save</Button>

          </div>
        </div>
      </div>
      )}
    </React.Fragment>
  );
};

export default FormCreateGpaForecastModal;